import http from '@/communication/AuthConnection'
export default async ({ commit }, { eventId }) => {
  try {
    const { data } = await http.get(`/v1/rms/${eventId}`)
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/brain/event-rms/LoadRms.js